import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'hoursToDecimal',
  standalone: true,
})
export class HoursToDecimalPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(timeInHours: number | null | undefined): string {
    if (timeInHours == null || isNaN(timeInHours)) {
      timeInHours = 0;
    }
    const probeValue = 1.1;
    const separator = probeValue
      .toLocaleString(this.translate.getCurrentLang() ?? undefined)
      .substring(1, 2);
    const formatted = timeInHours.toFixed(2).replace('.', separator);

    return formatted;
  }
}
